module.exports = __webpack_public_path__ + "static/media/infoJumbo1.be8a3a98.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/pages/supplier/loewer/images/infoJumbo1.png
// module id = 519
// module chunks = 0